import { render } from "./Users.vue?vue&type=template&id=a97f7272"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=a97f7272&lang=scss"

import exportComponent from "/Users/giacomo/Developer/tandu/barbera/barberabilance-docs-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__